import { render, staticRenderFns } from "./EstateSellPage.vue?vue&type=template&id=90e2ad2a"
import script from "./EstateSellPage.vue?vue&type=script&lang=js"
export * from "./EstateSellPage.vue?vue&type=script&lang=js"
import style0 from "./EstateSellPage.vue?vue&type=style&index=0&id=90e2ad2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports